import Swal from "sweetalert2";

const ModernSwal = Swal.mixin({
  customClass: {
    container: "z-[99999]",
    popup: "rounded-2xl shadow-xl",
    title: "text-xl font-bold text-slate-800",
    htmlContainer: "text-slate-600",
    confirmButton:
      "bg-slate-800 text-white px-6 py-2.5 rounded-lg font-bold shadow-md hover:bg-slate-900 focus:ring-4 focus:ring-slate-300 transition-all transform hover:-translate-y-0.5",
    cancelButton:
      "bg-slate-100 text-slate-700 px-6 py-2.5 rounded-lg font-bold hover:bg-slate-200 focus:ring-4 focus:ring-slate-100 transition-all transform hover:-translate-y-0.5",
    actions: "gap-4",
  },
  buttonsStyling: false,
  reverseButtons: true, // Cancel left, Confirm right (or vice versa depending on preference, usually Cancel left, Confirm right in modern web apps, but Swal defaults Confirm left. reverseButtons: true puts Confirm right)
});

export const showConfirmDialog = ({ title, text, html, icon = "warning", confirmText = "ยืนยัน", cancelText = "ยกเลิก" }) => {
    return ModernSwal.fire({
        title,
        text,
        html,
        icon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
    });
};

export default ModernSwal;
